<template>
  <div style="padding: 15px">
    <div style="margin-bottom: 20px;">
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        highlight-hover-row
        row-id="id"
        height="500"
        show-footer
        :footer-method="footerMethod"
        :loading="loading"
        :data="tableData"
      >
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="300"
        />
        <vxe-table-column
          field="shipperDeliveryFee"
          title="运费"
          min-width="130"
        />
        <vxe-table-column
          field="shipperAddress"
          title="装货地址"
          min-width="300"
        />
        <vxe-table-column
          field="consigneeAddress"
          title="收货地址"
          min-width="300"
        />
        <vxe-table-column
          field="gmtCreated"
          title="运单创建时间"
          min-width="300"
        />
      </vxe-table>
    </div>
  </div>
</template>
<script>
import { collectionDetail } from "@/api/category";
export default {
  name: "Detail",
  data() {
    return {
      loading: false,
      tableData: [],
      collectionAccountCheck:{}
    };
  },
  created() {},
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.tableData = [];
      collectionDetail(code).then(response => {
        this.tableData = response.data.detailList;
        this.collectionAccountCheck = response.data.collectionAccountCheck
      });
    },
    // 费用合计
    footerMethod({ columns, data }) {
      const sums = [];
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push("费用合计");
        } else {
          let sumCell = "-";
          if (column.property === "shipperDeliveryFee") {
            sumCell = this.$XEUtils.sum(data, column.property);
          }
          sums.push(sumCell);
        }
      });
      // 返回一个二维数组的表尾合计
      return [sums]; 
    }
  }
};
</script>
